import {
  CREATE_ORGANISASI_TIPE_SUCCESS,
  RETRIEVE_ORGANISASI_TIPE_SUCCESS,
  UPDATE_ORGANISASI_TIPE_SUCCESS,
  DELETE_ORGANISASI_TIPE_SUCCESS,
} from "../actions/types";

const initialState = [];

function organisasiTipeReducer(organisasi_tipes = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_ORGANISASI_TIPE_SUCCESS:
      return [...organisasi_tipes, payload];

    case RETRIEVE_ORGANISASI_TIPE_SUCCESS:
      return payload;

    case UPDATE_ORGANISASI_TIPE_SUCCESS:
      return organisasi_tipes.map((organisasi_tipe) => {
        if (organisasi_tipe.id === payload.id) {
          return {
            ...organisasi_tipe,
            ...payload,
          };
        } else {
          return organisasi_tipe;
        }
      });

    case DELETE_ORGANISASI_TIPE_SUCCESS:
      return organisasi_tipes.filter(({ id }) => id !== payload.id);

    default:
      return organisasi_tipes;
  }
}

export default organisasiTipeReducer;
